import { useMemo } from 'react'
import { useCurrentAppType } from 'hooks'
import steps from './Steps'
import { not, or, path, propEq, reject } from 'ramda'
import { useSelector } from 'react-redux'

const useGetSteps = () => {
  const { isWellpower } = useCurrentAppType()
  const isSecondaryUser = useSelector(path(['user', 'isSecondaryUser']))
  const enableGoals = useSelector(path(['school', 'enable_preset_goals']))

  const stepsToRender = useMemo(() => {
    let copy = [...steps]
    if (isWellpower) copy = reject(propEq('email', 'name'), copy)
    if (not(isWellpower)) copy = reject(propEq('wellpower', 'name'), copy)
    if (or(isSecondaryUser, not(enableGoals)))
      copy = reject(propEq('goals', 'name'), copy)
    return copy
  }, [isWellpower, isSecondaryUser, enableGoals])

  return stepsToRender
}

export default useGetSteps
